import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LinqFormsModule } from '../../forms/forms.module';
import { SharedModule } from '../../shared.module';
import { ChangeHistoryButtonComponent } from './button/change-history-button.component';
import { ChangeHistoryComponent } from './change-history.component';
import { ChangeHistoryService } from './services/change-history.service';

const components = [ChangeHistoryButtonComponent, ChangeHistoryComponent];

@NgModule({
    exports: [...components],
    imports: [CommonModule, SharedModule, LinqFormsModule, ...components],
    providers: [ChangeHistoryService],
})
export class ChangeHistoryModule {}
